module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-submit",
    attrs: {
      "id": "filtersubmit"
    }
  }, [_c('button', {
    staticClass: "filter-submit-button",
    on: {
      "click": _vm.goTo
    }
  }, [_vm._v("\n      Reload "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cached")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-407abf28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterSubmitButton.vue
// module id = 462
// module chunks = 1